import { render, staticRenderFns } from "./PurchaseOtherPaymentView.vue?vue&type=template&id=ad18608a"
import script from "./PurchaseOtherPaymentView.vue?vue&type=script&lang=js"
export * from "./PurchaseOtherPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports